import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e5cb108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "system-status-bar flex flex-wrap align-items-center justify-content-between column-gap-4 row-gap-2 px-3 py-2 border-bottom-1 surface-border surface-section" }
const _hoisted_2 = { class: "flex flex-wrap align-items-center column-gap-3 row-gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold text-color-secondary mr-1" }, "System Status", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-xs font-semibold text-red-500 ml-1"
}
const _hoisted_5 = { class: "flex flex-wrap align-items-center column-gap-3 row-gap-1 text-sm" }
const _hoisted_6 = { class: "text-color font-semibold ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subsystems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: "flex align-items-center gap-2"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["status-dot", item.ok ? 'status-dot--ok' : 'status-dot--down'])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["text-sm", item.ok ? 'text-color' : 'text-red-500 font-medium'])
          }, _toDisplayString(item.label), 3)
        ]))
      }), 128)),
      (!_ctx.allOk)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.alertSimulation ? 'Alert simulation' : 'ALERT'), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.environment, (reading) => {
        return (_openBlock(), _createElementBlock("span", {
          key: reading.label,
          class: "text-color-secondary"
        }, [
          _createTextVNode(_toDisplayString(reading.label) + " ", 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(reading.value) + _toDisplayString(reading.unit), 1)
        ]))
      }), 128)),
      _withDirectives(_createVNode(_component_PButton, {
        icon: _ctx.alertMuted ? 'pi pi-volume-off' : 'pi pi-volume-up',
        severity: !_ctx.allOk && !_ctx.alertMuted ? 'danger' : 'secondary',
        class: _normalizeClass({ 'alert-mute-btn--active': !_ctx.allOk && !_ctx.alertMuted }),
        rounded: "",
        text: "",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMute()))
      }, null, 8, ["icon", "severity", "class"]), [
        [
          _directive_tooltip,
          _ctx.alertMuted ? 'Unmute status alerts' : 'Mute status alerts',
          void 0,
          { left: true }
        ]
      ])
    ])
  ]))
}